import { type FC } from "react";

const ErrorUI: FC<{ error: Error }> = () => {
  return <div>Something goes wrong...</div>;
};

export default ErrorUI;
